import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Locale = "en" | "es" | "pt" | "fr" | "de" | "it" | "ja" | "zh";

export const SUPPORTED_LOCALES: Record<Locale, { name: string; flag: string }> =
  {
    en: { name: "English", flag: "🇬🇧" },
    es: { name: "Español", flag: "🇪🇸" },
    pt: { name: "Português", flag: "🇧🇷" },
    fr: { name: "Français", flag: "🇫🇷" },
    de: { name: "Deutsch", flag: "🇩🇪" },
    it: { name: "Italiano", flag: "🇮🇹" },
    ja: { name: "日本語", flag: "🇯🇵" },
    zh: { name: "中文", flag: "🇨🇳" },
  };

interface LocaleState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: "en",
      setLocale: (locale: Locale) => set({ locale }),
    }),
    {
      name: "imoova-locale",
    },
  ),
);

export function useLocale() {
  return useLocaleStore((store) => store.locale);
}
